import { Condition } from "shared/src/data/medication-condition-pairs";

export type ScreenPersonalizationInput = {
  Condition: string;
  Screens: Screen[];
};

export type Screen = {
  Screen_Name: string;
  Fields: Field[];
};

export type Field = {
  Field_Name: string;
  Field_Value: string;
  Order_No: number;
};

type ScreenPersonalizationInputs = ScreenPersonalizationInput[];

export type DynamicSuggestions = {
  ScreenPersonalizationInputs: ScreenPersonalizationInputs;
};

export const dynamicSuggestions: DynamicSuggestions = {
  ScreenPersonalizationInputs: [
    {
      Condition: Condition.RHEUMATOID_ARTHRITIS,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value: "I have trouble buttoning my clothes",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Gripping things can be hard",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "I'm always exhausted",
              Order_No: 3,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "It feels like my ankles might break",
              Order_No: 4,
            },
          ],
        },
      ],
    },
    {
      Condition: Condition.GOUT,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value: "My joints are excruciatingly tender",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "I have trouble sleeping because of the pain",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "It feels like my joints are on fire",
              Order_No: 3,
            },
          ],
        },
      ],
    },
    {
      Condition: Condition.MIGRAINE,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value: "Severe headaches",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Visual aura",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Trouble speaking",
              Order_No: 3,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Cannot drive",
              Order_No: 4,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "I miss 3 days of work per month",
              Order_No: 5,
            },
          ],
        },
      ],
    },
    {
      Condition: Condition.CROHNS_DISEASE,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value: "I feel nauseated",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "I have cramping pains",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Blood in stool",
              Order_No: 3,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Hospital admissions",
              Order_No: 4,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Issues with eating",
              Order_No: 5,
            },
          ],
        },
      ],
    },
    {
      Condition: Condition.ULCERATIVE_COLITIS,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value: "I feel nauseated",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "I have cramping pains",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Blood in stool",
              Order_No: 3,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Hospital admissions",
              Order_No: 4,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Issues with eating",
              Order_No: 5,
            },
          ],
        },
      ],
    },
    {
      Condition: Condition.PLAQUE_PSORIASIS,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value: "My skin feels like it's on fire",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Itching is unbearable at night",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Simple tasks hurt my brittle nails",
              Order_No: 3,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "It's painful to move my dry skin",
              Order_No: 4,
            },
          ],
        },
      ],
    },
    {
      Condition: Condition.PSORIATIC_ARTHRITIS,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value: "I'm too swollen to grip things",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Heel pain makes every step a struggle",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "I'm so tender that clothing hurts",
              Order_No: 3,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "I feel like my toes might burst",
              Order_No: 4,
            },
          ],
        },
      ],
    },
    {
      Condition: Condition.ANKYLOSING_SPONDYLITIS,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value: "Breathing deeply hurts",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Hip pain makes it hard to walk",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "I can't turn my head",
              Order_No: 3,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "It feels like my back is locked up",
              Order_No: 4,
            },
          ],
        },
      ],
    },
    {
      Condition: Condition.NON_RADIOGRAPHIC_AXIAL_SPONDYLOARTHRITIS,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value: "Breathing deeply hurts",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Hip pain makes it hard to walk",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "I can't turn my head",
              Order_No: 3,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "It feels like my back is locked up",
              Order_No: 4,
            },
          ],
        },
      ],
    },
    {
      Condition: Condition.PANS,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value: "Completely bed bound",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Screams in pain 8 hours a day",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Lives in a state of fear",
              Order_No: 3,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "No longer able to write",
              Order_No: 4,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Unable to go to school",
              Order_No: 5,
            },
          ],
        },
      ],
    },
    {
      Condition: Condition.PANDAS,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value: "Completely bed bound",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Screams in pain 8 hours a day",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Lives in a state of fear",
              Order_No: 3,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "No longer able to write",
              Order_No: 4,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Unable to go to school",
              Order_No: 5,
            },
          ],
        },
      ],
    },
    {
      Condition: Condition.OBESITY,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value: "Food cravings make it hard to focus",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "I never feel rested",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Every step is painful",
              Order_No: 3,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "I run out of breath doing the smallest things",
              Order_No: 4,
            },
          ],
        },
      ],
    },
    {
      Condition: Condition.TYPE_2_DIABETES,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value: "Numbness and tingling in my feet",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "I never feel rested",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Vision gets blurry when my sugar spikes",
              Order_No: 3,
            },
          ],
        },
      ],
    },
    {
      Condition: Condition.MASH,
      Screens: [
        {
          Screen_Name: "Symptom_Story",
          Fields: [
            {
              Field_Name: "Suggestions",
              Field_Value:
                "I'm constantly exhausted no matter how much I sleep",
              Order_No: 1,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "My upper abdomen aches and feels tender",
              Order_No: 2,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "Brain fog makes it hard to focus at work",
              Order_No: 3,
            },
            {
              Field_Name: "Suggestions",
              Field_Value: "I have no appetite and feel nauseous",
              Order_No: 4,
            },
          ],
        },
      ],
    },
  ],
};
